<script lang="ts" setup>
  import type { PlayersGuessingView } from '../../../../shared/api/round.ts';
  import type { Song } from '../../../../shared/api/song.ts';
  import { MobileViewLayout } from '../../../../shared/ui/mobile-view-layout';
  import SongSearch from '../song/SongSearch.vue';
  import RoundHeader from './RoundHeader.vue';

  defineProps<{
    data: PlayersGuessingView;
    secondsLeft: string;
    isHost: boolean;
    songs: Song[];
    isLoading: boolean;
    error: string;
    searchError?: string;
  }>();
  defineEmits<{ search: [query: string]; guessedSong: [song: Song] }>();
  const songSearchQuery = defineModel<string>();
</script>

<template>
  <MobileViewLayout space="m">
    <template #header>
      <RoundHeader :is-host="isHost" :seconds-left="secondsLeft" :view="data" />
    </template>

    <SongSearch
      v-model="songSearchQuery"
      :disabled="data.paused"
      :is-loading="isLoading"
      :search-error="searchError"
      :songs="songs"
      loading-label="Guessing song…"
      placeholder="Guess song"
      @song-selected="$emit('guessedSong', $event)"
    >
      <div v-if="data.round.chooser" class="chooser-info">
        <span class="chooser-label">Guess the song that</span>
        <span class="chooser-name">{{ data.round.chooser.nickname }}</span>
        <span class="chooser-label">chose!</span>
      </div>
      <div v-else class="chooser-info">
        <span class="chooser-name">Guess the song!</span>
      </div>
      <p v-if="error" class="error">{{ error }}</p>
    </SongSearch>
  </MobileViewLayout>
</template>

<style scoped>
  .error {
    color: var(--color-error);
    margin: 0 0 0.25rem;
    text-align: center;
  }

  .chooser-info {
    align-items: center;
    display: flex;
    flex-direction: column;
    gap: 0.25rem;
    margin-bottom: 0.5rem;
  }

  .chooser-label {
    color: var(--color-text-muted);
    font-size: var(--font-size-xs);
    letter-spacing: 0.1em;
    text-align: center;
    text-transform: uppercase;
  }

  .chooser-name {
    color: var(--color-primary);
    font-family: var(--font-nickname);
    font-size: var(--font-size-lg);
    line-height: 1.1;
    text-align: center;
    text-transform: uppercase;
  }
</style>
